import React from 'react';
import styled from 'styled-components';
import { OptionProps } from 'react-select';

import theme from '../../../styles/userflow';
import { Check as IconCheck } from '@icons/common';

export type OptionType = React.FC<OptionProps<{ value; label }>>;

const Option: OptionType = props => {
  const { innerProps, isSelected, innerRef, isFocused, data } = props;

  const { value, label } = data;

  return (
    <StyledDeparture
      // @ts-ignore
      ref={innerRef}
      {...innerProps}
      isFocused={isFocused}
      notFound={value === ''}
    >
      {label}
      {isSelected && <StyledIconCheck />}
    </StyledDeparture>
  );
};

const StyledDeparture = styled.div<{
  isFocused: boolean;
  notFound: boolean;
}>`
  display: flex;
  align-items: center;
  padding: 0 8px;
  border-top: 1px solid ${theme.colors.whiteLight};

  width: 100%;
  height: 48px;

  font-size: 14px;
  line-height: 16px;
  font-weight: normal;
  background-color: ${({ isFocused }) => isFocused && theme.colors.solitude};

  &:hover {
    cursor: pointer;
    background-color: ${theme.colors.solitude};
  }

  &:first-child {
    border-top: none;
  }

  ${({ notFound }) => notFound && 'text-align: center; color: grey;'}
`;

const StyledIconCheck = styled(IconCheck)`
  width: 14px;
  height: 10px;
  margin-left: auto;
  margin-right: 10px;
  stroke: ${theme.colors.blackBase};
`;

export default Option;
